// Mock data for Explora Journeys Landing Page
// Filter: Only itineraries with 10 nights or less

import { additionalItineraries } from './additionalItineraries';

const baseItineraries = [
  // Monaco F1 Grand Prix Itineraries 2026
  {
    id: 'EX20260603MCMMCM',
    name: 'Monaco F1® Race Weekend, Reimagined',
    ship: 'EXPLORA I',
    duration: '5 nights',
    year: 2026,
    sortDate: new Date('2026-06-03'),
    departureDate: 'June 3, 2026',
    returnDate: 'June 8, 2026',
    departurePort: 'Monte Carlo, Monaco',
    arrivalPort: 'Monte Carlo, Monaco',
    priceFrom: '₹11,62,000',
    region: 'Mediterranean',
    highlights: 'Monte Carlo (Monaco) - 6 nights in Port Hercule during F1 Grand Prix',
    category: 'monaco-gp',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/g5z2rmej_CVVBCN-13-V1.webp',
    dailyItinerary: [
      {
        day: 1,
        date: 'June 3, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'Embarkation',
        departure: 'Overnight',
        description: 'Arrive in Monaco as EXPLORA I takes its exclusive position within Port Hercule. Settle into your ocean sanctuary before the excitement begins.'
      },
      {
        day: 2,
        date: 'June 4, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Overnight',
        description: 'Formula 2 and Formula 3 practice sessions. Explore boutique-lined streets, Prince\'s Palace, and Casino Square.'
      },
      {
        day: 3,
        date: 'June 5, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Overnight',
        description: 'Formula 1® practice and Formula 2/3 qualifying. Experience the Paddock Club™ or Grandstand access (optional upgrade).'
      },
      {
        day: 4,
        date: 'June 6, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Overnight',
        description: 'Formula 1® qualifying day! Watch drivers battle for pole position around Monaco\'s legendary circuit.'
      },
      {
        day: 5,
        date: 'June 7, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Overnight',
        description: 'RACE DAY! The Formula 1 Grand Prix de Monaco unfolds almost within touching distance. Celebrations light up the principality.'
      },
      {
        day: 6,
        date: 'June 8, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Disembarkation',
        description: 'Disembarkation after an unforgettable race weekend where the thrill of Formula 1® meets the serenity of the sea.'
      }
    ]
  },
  {
    id: 'EX20260602CVVCVV',
    name: 'Monaco F1® Race Weekend, Reimagined',
    ship: 'EXPLORA I',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-06-02'),
    departureDate: 'June 2, 2026',
    returnDate: 'June 9, 2026',
    departurePort: 'Civitavecchia (Rome), Italy',
    arrivalPort: 'Civitavecchia (Rome), Italy',
    priceFrom: '₹14,11,000',
    region: 'Mediterranean',
    highlights: 'Civitavecchia (Rome), Portofino, Monte Carlo (Monaco F1), At Sea',
    category: 'monaco-gp',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/g5z2rmej_CVVBCN-13-V1.webp',
    dailyItinerary: [
      {
        day: 1,
        date: 'June 2, 2026',
        port: 'Civitavecchia (Rome), Italy',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Board EXPLORA I in Rome\'s port. Explore eternal Rome or relax onboard before your Riviera journey begins.'
      },
      {
        day: 2,
        date: 'June 3, 2026',
        port: 'Portofino, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover the enchanting harbor village of Portofino, with its colorful buildings and yacht-filled marina.'
      },
      {
        day: 3,
        date: 'June 4, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: '08:00',
        departure: 'Overnight',
        description: 'Arrive Monaco for F2/F3 practice sessions. Explore Monte Carlo\'s glamorous streets and Casino Square.'
      },
      {
        day: 4,
        date: 'June 5, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Overnight',
        description: 'Formula 1® practice and qualifying sessions. Optional Paddock Club™ or Grandstand access.'
      },
      {
        day: 5,
        date: 'June 6, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: 'Overnight',
        description: 'F1® qualifying day and F2/3 Sprint Races. Watch the action unfold from your exclusive vantage point.'
      },
      {
        day: 6,
        date: 'June 7, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: 'In Port',
        departure: '18:00',
        description: 'RACE DAY! Experience the Monaco Grand Prix, then celebrate as the ship departs the illuminated principality.'
      },
      {
        day: 7,
        date: 'June 8, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax at sea. Enjoy spa treatments, culinary experiences, and reflect on your Grand Prix adventure.'
      },
      {
        day: 8,
        date: 'June 9, 2026',
        port: 'Civitavecchia (Rome), Italy',
        arrival: '07:00',
        departure: 'Disembarkation',
        description: 'Return to Civitavecchia. Disembark with unforgettable memories of Monaco\'s most iconic weekend.'
      }
    ]
  },
  
  // Mediterranean Itineraries 2026
  {
    id: 'EX20260706BCNCVV',
    name: 'Western Mediterranean Discovery',
    ship: 'EXPLORA I',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-07-06'),
    departureDate: 'July 6, 2026',
    returnDate: 'July 13, 2026',
    departurePort: 'Barcelona, Spain',
    arrivalPort: 'Civitavecchia (Rome), Italy',
    priceFrom: '₹7,05,500',
    region: 'Mediterranean',
    highlights: 'Barcelona, Ibiza, Tunis, Valletta, Taormina, Sorrento, Civitavecchia (Rome)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_bb879a25-df97-4746-b221-34f98bc25802/artifacts/t23y0e2x_iStock-1380534040.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'July 6, 2026',
        port: 'Barcelona, Spain',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Begin your journey in Barcelona, where lively arts scene buzzes with joyful energy.'
      },
      {
        day: 2,
        date: 'July 7, 2026',
        port: 'Ibiza, Spain',
        arrival: '08:00',
        departure: '22:00',
        description: 'Feel Ibiza\'s dual rhythm of tranquil beaches and pulsing nightlife.'
      },
      {
        day: 3,
        date: 'July 8, 2026',
        port: 'Tunis, Tunisia',
        arrival: '08:00',
        departure: '18:00',
        description: 'Enter Tunis\'s rich Tunisian souks and mosaics.'
      },
      {
        day: 4,
        date: 'July 9, 2026',
        port: 'Valletta, Malta',
        arrival: '08:00',
        departure: '18:00',
        description: 'Stroll through Valletta\'s golden fortresses and historic streets.'
      },
      {
        day: 5,
        date: 'July 10, 2026',
        port: 'Taormina, Sicily, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Explore Taormina\'s Greco-Roman hilltop streets and stunning views.'
      },
      {
        day: 6,
        date: 'July 11, 2026',
        port: 'Sorrento, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Gaze over cliffs to Vesuvian views in beautiful Sorrento.'
      },
      {
        day: 7,
        date: 'July 12, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax and enjoy the ship\'s amenities as you cruise towards Rome.'
      },
      {
        day: 8,
        date: 'July 13, 2026',
        port: 'Civitavecchia (Rome), Italy',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Arrive in the Eternal City, where ancient wonders and modern vibrancy create a perfect finale.'
      }
    ]
  },
  {
    id: 'EX20260727CVVBCN',
    name: 'Shimmering Shores & Mediterranean Treasures',
    ship: 'EXPLORA I',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-07-27'),
    departureDate: 'July 27, 2026',
    returnDate: 'August 3, 2026',
    departurePort: 'Civitavecchia (Rome), Italy',
    arrivalPort: 'Barcelona, Spain',
    priceFrom: '₹7,05,500',
    region: 'Mediterranean',
    highlights: 'Civitavecchia (Rome), Naples, Capri, Calvi (Corsica), Villefranche-sur-Mer, Marseille, Mahón (Menorca), Barcelona',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/mmb4mrl6_rome.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'July 27, 2026',
        port: 'Civitavecchia (Rome), Italy',
        arrival: 'Embarkation',
        departure: '20:00',
        description: 'Uncover the hidden treasures of the Eternal City before embarking on your Mediterranean journey.'
      },
      {
        day: 2,
        date: 'July 28, 2026',
        port: 'Naples, Italy',
        arrival: '08:00',
        departure: '17:00',
        description: 'Experience the essence of Italian heritage in Naples\' story-steeped streets and vibrant culture.'
      },
      {
        day: 3,
        date: 'July 29, 2026',
        port: 'Capri, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Mythical beauty enchants the senses on this legendary island paradise.'
      },
      {
        day: 4,
        date: 'July 30, 2026',
        port: 'Calvi, Corsica, France',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover Corsica\'s peaceful landscapes and dramatic coastal scenery.'
      },
      {
        day: 5,
        date: 'July 31, 2026',
        port: 'Villefranche-sur-Mer, France',
        arrival: '08:00',
        departure: '18:00',
        description: 'Experience the sparkling shores of the French Riviera in this charming Mediterranean gem.'
      },
      {
        day: 6,
        date: 'August 1, 2026',
        port: 'Marseille, France',
        arrival: '08:00',
        departure: '18:00',
        description: 'Vibrant traditions beckon in France\'s oldest city, where Mediterranean culture thrives.'
      },
      {
        day: 7,
        date: 'August 2, 2026',
        port: 'Mahón, Menorca, Spain',
        arrival: '08:00',
        departure: '18:00',
        description: 'An oasis of calm in the Balearic Islands with pristine beaches and tranquil harbors.'
      },
      {
        day: 8,
        date: 'August 3, 2026',
        port: 'Barcelona, Spain',
        arrival: '07:00',
        departure: 'Disembarkation',
        description: 'Immerse yourself in Barcelona\'s colourful heart, where heritage, artistry and Mediterranean beauty converge.'
      }
    ]
  },
  {
    id: 'EX20260424PIRBCN',
    name: 'Greek Islands to Barcelona',
    ship: 'EXPLORA I',
    duration: '9 nights',
    year: 2026,
    sortDate: new Date('2026-04-24'),
    departureDate: 'April 24, 2026',
    returnDate: 'May 3, 2026',
    departurePort: 'Piraeus (Athens), Greece',
    arrivalPort: 'Barcelona, Spain',
    priceFrom: '₹7,63,600',
    region: 'Mediterranean',
    highlights: 'Piraeus (Athens), Milos, Crete, Taormina, Valletta, Tunis, Ibiza, Barcelona',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/j6lsfh5x_Greece.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'April 24, 2026',
        port: 'Piraeus (Athens), Greece',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Start your journey in Athens, where ancient marvels blend with contemporary energy.'
      },
      {
        day: 2,
        date: 'April 25, 2026',
        port: 'Milos, Greece',
        arrival: '08:00',
        departure: '18:00',
        description: 'Glide onwards to the famed beaches of Milos with sapphire waters and chalk-white cliffs.'
      },
      {
        day: 3,
        date: 'April 26, 2026',
        port: 'Crete, Greece',
        arrival: '08:00',
        departure: '18:00',
        description: 'Dive into Crete\'s timeless culture and ancient heritage.'
      },
      {
        day: 4,
        date: 'April 27, 2026',
        port: 'Taormina, Sicily, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Taormina enchants with Sicilian charm and stunning coastal views.'
      },
      {
        day: 5,
        date: 'April 28, 2026',
        port: 'Valletta, Malta',
        arrival: '08:00',
        departure: '18:00',
        description: 'Valletta reveals layers of rich history and golden fortresses.'
      },
      {
        day: 6,
        date: 'April 29, 2026',
        port: 'Tunis, Tunisia',
        arrival: '08:00',
        departure: '18:00',
        description: 'Wander through the echoes of the past in Tunis.'
      },
      {
        day: 7,
        date: 'April 30, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Enjoy a relaxing day at sea with all onboard amenities.'
      },
      {
        day: 8,
        date: 'May 1, 2026',
        port: 'Ibiza, Spain',
        arrival: '08:00',
        departure: '22:00',
        description: 'Ibiza offers a bohemian island escape with stunning beaches.'
      },
      {
        day: 9,
        date: 'May 2, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Final day at sea as we cruise towards Barcelona.'
      },
      {
        day: 10,
        date: 'May 3, 2026',
        port: 'Barcelona, Spain',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Finally sailing to Barcelona, we celebrate the vibrant city\'s soul.'
      }
    ]
  },
  {
    id: 'EP20260608FSAPIR',
    name: 'Adriatic Wonders',
    ship: 'EXPLORA II',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-06-08'),
    departureDate: 'June 8, 2026',
    returnDate: 'June 15, 2026',
    departurePort: 'Venice (Fusina), Italy',
    arrivalPort: 'Piraeus (Athens), Greece',
    priceFrom: '₹7,30,400',
    region: 'Mediterranean',
    highlights: 'Venice (Fusina), Rovinj, Zadar, Dubrovnik, Brindisi, Milos, Piraeus (Athens)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/04pdud8j_kotor.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'June 8, 2026',
        port: 'Venice (Fusina), Italy',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Waltzing from Venice\'s liquid gold, begin your Adriatic adventure.'
      },
      {
        day: 2,
        date: 'June 9, 2026',
        port: 'Rovinj, Croatia',
        arrival: '08:00',
        departure: '18:00',
        description: 'Dip into discovery of Rovinj\'s Istrian landscapes and medieval charm.'
      },
      {
        day: 3,
        date: 'June 10, 2026',
        port: 'Zadar, Croatia',
        arrival: '08:00',
        departure: '18:00',
        description: 'Experience Zadar\'s enchanting ocean rhythms and Sea Organ.'
      },
      {
        day: 4,
        date: 'June 11, 2026',
        port: 'Dubrovnik, Croatia',
        arrival: '08:00',
        departure: '18:00',
        description: 'Stroll in the intricate alleys of Dubrovnik\'s walled city.'
      },
      {
        day: 5,
        date: 'June 12, 2026',
        port: 'Brindisi, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Explore the spectacular monuments of this historic Apulian port.'
      },
      {
        day: 6,
        date: 'June 13, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'A relaxing and enriching day onboard with world-class amenities.'
      },
      {
        day: 7,
        date: 'June 14, 2026',
        port: 'Milos, Greece',
        arrival: '08:00',
        departure: '18:00',
        description: 'Reach the cinematic beaches of Milos, where sapphire waters meet chalk-white cliffs.'
      },
      {
        day: 8,
        date: 'June 15, 2026',
        port: 'Piraeus (Athens), Greece',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Embrace the blend of history, mythology and modern wonders in glorious Athens.'
      }
    ]
  },

  // Additional Mediterranean Itineraries 2026
  {
    id: 'EX20260503BCNCVV',
    name: 'Mediterranean Architecture & Culture',
    ship: 'EXPLORA I',
    duration: '10 nights',
    year: 2026,
    sortDate: new Date('2026-05-03'),
    departureDate: 'May 3, 2026',
    returnDate: 'May 13, 2026',
    departurePort: 'Barcelona, Spain',
    arrivalPort: 'Civitavecchia (Rome), Italy',
    priceFrom: '₹8,71,500',
    region: 'Mediterranean',
    highlights: 'Barcelona, Cádiz, Tangier, Motril, Cartagena, Saint-Tropez, Monte Carlo, Livorno (Florence), Civitavecchia (Rome)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/xdaum4pb_barcelona.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'May 3, 2026',
        port: 'Barcelona, Spain',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Absorb the energy of arty Barcelona, where Catalan creativity meets coastal beauty.'
      },
      {
        day: 2,
        date: 'May 4, 2026',
        port: 'Cádiz, Spain',
        arrival: '08:00',
        departure: '18:00',
        description: 'Stroll along the quaint cobbles of Cádiz, one of Europe\'s oldest continuously inhabited cities.'
      },
      {
        day: 3,
        date: 'May 5, 2026',
        port: 'Tangier, Morocco',
        arrival: '08:00',
        departure: '18:00',
        description: 'Feel the cultural vibrancy of Tangier at the meeting point of continents.'
      },
      {
        day: 4,
        date: 'May 6, 2026',
        port: 'Motril, Spain',
        arrival: '08:00',
        departure: '18:00',
        description: 'Soak up Motril\'s tropical warmth and Mediterranean charm.'
      },
      {
        day: 5,
        date: 'May 7, 2026',
        port: 'Cartagena, Spain',
        arrival: '08:00',
        departure: '18:00',
        description: 'Uncover centuries of layered history in the ancient port of Cartagena.'
      },
      {
        day: 6,
        date: 'May 8, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax and enjoy the ship\'s world-class amenities.'
      },
      {
        day: 7,
        date: 'May 9, 2026',
        port: 'Saint-Tropez, France',
        arrival: '08:00',
        departure: '18:00',
        description: 'Experience the glittering shores of Saint-Tropez with sophisticated glamour.'
      },
      {
        day: 8,
        date: 'May 10, 2026',
        port: 'Monte Carlo, Monaco',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover Monte Carlo\'s legendary elegance and Mediterranean sparkle.'
      },
      {
        day: 9,
        date: 'May 11, 2026',
        port: 'Livorno (Florence), Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Venture to the cultural marvels of Florence through nearby Livorno.'
      },
      {
        day: 10,
        date: 'May 12, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Final day at sea sailing towards Rome.'
      },
      {
        day: 11,
        date: 'May 13, 2026',
        port: 'Civitavecchia (Rome), Italy',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Immersed in antiquity, Rome invites you to uncover its stunning historical gems.'
      }
    ]
  },
  {
    id: 'EX20260527BCNCVV',
    name: 'Catalan Colours to Roman Grandeur',
    ship: 'EXPLORA I',
    duration: '6 nights',
    year: 2026,
    sortDate: new Date('2026-05-27'),
    departureDate: 'May 27, 2026',
    returnDate: 'June 2, 2026',
    departurePort: 'Barcelona, Spain',
    arrivalPort: 'Civitavecchia (Rome), Italy',
    priceFrom: '₹6,80,600',
    region: 'Mediterranean',
    highlights: 'Barcelona, Mahón (Menorca), Alghero (Sardinia), Cannes, Saint-Tropez, Civitavecchia (Rome)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_bb879a25-df97-4746-b221-34f98bc25802/artifacts/iap05l6f_iStock-695920628.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'May 27, 2026',
        port: 'Barcelona, Spain',
        arrival: 'Embarkation',
        departure: '18:00',
        description: 'Begin in vibrant Barcelona, where Catalan creativity and coastal charm captivate.'
      },
      {
        day: 2,
        date: 'May 28, 2026',
        port: 'Mahón, Menorca',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover the unhurried lifestyle and sea-swept views of Mahón, inviting quiet exploration.'
      },
      {
        day: 3,
        date: 'May 29, 2026',
        port: 'Alghero, Sardinia, Italy',
        arrival: '08:00',
        departure: '18:00',
        description: 'Experience the rugged beauty of Sardinia\'s Coral Coast, rich in tradition and natural wonder.'
      },
      {
        day: 4,
        date: 'May 30, 2026',
        port: 'Cannes, France',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover the cinematic charm of Cannes along the French Riviera.'
      },
      {
        day: 5,
        date: 'May 31, 2026',
        port: 'Saint-Tropez, France',
        arrival: '08:00',
        departure: '22:00',
        description: 'Experience the sunlit glamour of St Tropez and Mediterranean elegance.'
      },
      {
        day: 6,
        date: 'June 1, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax and reflect on your Mediterranean journey.'
      },
      {
        day: 7,
        date: 'June 2, 2026',
        port: 'Civitavecchia (Rome), Italy',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Your journey culminates in Rome, where layers of history and culture unfold.'
      }
    ]
  },
  
  // Middle East Itineraries 2026-2027
  {
    id: 'EP20261221DXBDXB',
    name: 'Meditative Moments in the Arabian Gulf',
    ship: 'EXPLORA II',
    duration: '7 nights',
    year: 2026,
    sortDate: new Date('2026-12-21'),
    departureDate: 'December 21, 2026',
    returnDate: 'December 28, 2026',
    departurePort: 'Dubai, UAE',
    arrivalPort: 'Dubai, UAE',
    priceFrom: '₹4,64,600',
    region: 'Middle East',
    highlights: 'Dubai (2 days), Khor Fakkan, Sur, Muscat, Khasab, Dubai',
    category: 'middle-east',
    image: 'https://customer-assets.emergentagent.com/job_bb879a25-df97-4746-b221-34f98bc25802/artifacts/9a04r2op_iStock-1440358727.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'December 21, 2026',
        port: 'Dubai, UAE',
        arrival: 'Embarkation',
        departure: 'Overnight',
        description: 'Begin in Dubai\'s glittering metropolis with festive elegance aboard EXPLORA II.'
      },
      {
        day: 2,
        date: 'December 22, 2026',
        port: 'Dubai, UAE',
        arrival: 'Overnight',
        departure: '17:00',
        description: 'Extended stay in Dubai to explore the city\'s modern attractions and vibrant culture.'
      },
      {
        day: 3,
        date: 'December 23, 2026',
        port: 'Khor Fakkan, UAE',
        arrival: '08:00',
        departure: '17:00',
        description: 'Explore Khor Fakkan\'s biodiverse wadis and craggy coves.'
      },
      {
        day: 4,
        date: 'December 24, 2026',
        port: 'Sur, Oman',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover Sur\'s traditional dhow-building heritage and turtle beaches.'
      },
      {
        day: 5,
        date: 'December 25, 2026',
        port: 'Muscat, Oman',
        arrival: '08:00',
        departure: '18:00',
        description: 'Arrive in Muscat on Christmas Day, where historic forts and vibrant souks await.'
      },
      {
        day: 6,
        date: 'December 26, 2026',
        port: 'Khasab, Oman',
        arrival: '08:00',
        departure: '18:00',
        description: 'Explore Khasab\'s dramatic fjords and tranquil waters.'
      },
      {
        day: 7,
        date: 'December 27, 2026',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'Relax and enjoy all onboard amenities as we sail back to Dubai.'
      },
      {
        day: 8,
        date: 'December 28, 2026',
        port: 'Dubai, UAE',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Return to Dubai\'s sun-baked grandeur.'
      }
    ]
  },
  {
    id: 'EP20261228DXBDXB',
    name: 'Arabian Sparkle & New Year\'s Magic',
    ship: 'EXPLORA II',
    duration: '7 nights',
    year: 2027,
    sortDate: new Date('2026-12-28'),
    departureDate: 'December 28, 2026',
    returnDate: 'January 4, 2027',
    departurePort: 'Dubai, UAE',
    arrivalPort: 'Dubai, UAE',
    priceFrom: '₹6,28,220',
    region: 'Middle East',
    highlights: 'Dubai (2 days), Fujairah, Abu Dhabi, Bahrain (Manama), Doha, Dubai',
    category: 'middle-east',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/9kq7e7xs_dubai.jpg',
    dailyItinerary: [
      {
        day: 1,
        date: 'December 28, 2026',
        port: 'Dubai, UAE',
        arrival: 'Embarkation',
        departure: 'Overnight',
        description: 'Imbue your New Year celebrations aboard EXPLORA II from the buzz of Dubai.'
      },
      {
        day: 2,
        date: 'December 29, 2026',
        port: 'Dubai, UAE',
        arrival: 'Overnight',
        departure: '16:00',
        description: 'Extended time in Dubai to explore Sheikh Zayed Road and the city\'s modern skylines.'
      },
      {
        day: 3,
        date: 'December 30, 2026',
        port: 'Fujairah, UAE',
        arrival: '08:00',
        departure: '18:00',
        description: 'Sail to Fujairah City\'s serene beaches backed by mountains.'
      },
      {
        day: 4,
        date: 'December 31, 2026',
        port: 'Abu Dhabi, UAE',
        arrival: '08:00',
        departure: '23:59',
        description: 'Delight in onboard festivity as we welcome 2027 with fireworks that light the Arabian night sky.'
      },
      {
        day: 5,
        date: 'January 1, 2027',
        port: 'At Sea',
        arrival: '-',
        departure: '-',
        description: 'New Year\'s Day at sea - discover ship amenities after midnight celebrations.'
      },
      {
        day: 6,
        date: 'January 2, 2027',
        port: 'Bahrain (Manama)',
        arrival: '08:00',
        departure: '18:00',
        description: 'Sail to Manama to witness historic gems in this Arabian Gulf kingdom.'
      },
      {
        day: 7,
        date: 'January 3, 2027',
        port: 'Doha, Qatar',
        arrival: '08:00',
        departure: '18:00',
        description: 'Discover Doha, where striking skyscrapers blend with old tradition.'
      },
      {
        day: 8,
        date: 'January 4, 2027',
        port: 'Dubai, UAE',
        arrival: '08:00',
        departure: 'Disembarkation',
        description: 'Return to Dubai\'s shimmering coast.'
      }
    ]
  },
  
  // Mediterranean 2027
  {
    id: 'EX20270515BCNCVV',
    name: 'Spring Mediterranean',
    ship: 'EXPLORA I',
    duration: '7 nights',
    year: 2027,
    sortDate: new Date('2027-05-15'),
    departureDate: 'May 15, 2027',
    returnDate: 'May 22, 2027',
    departurePort: 'Barcelona, Spain',
    arrivalPort: 'Civitavecchia (Rome), Italy',
    priceFrom: '₹7,05,500',
    region: 'Mediterranean',
    highlights: 'Barcelona, Mediterranean ports, Riviera, Civitavecchia (Rome)',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/mmb4mrl6_rome.jpg'
  },
  {
    id: 'EX20270620CVVBCN',
    name: 'Summer Riviera',
    ship: 'EXPLORA I',
    duration: '7 nights',
    year: 2027,
    sortDate: new Date('2027-06-20'),
    departureDate: 'June 20, 2027',
    returnDate: 'June 27, 2027',
    departurePort: 'Civitavecchia (Rome), Italy',
    arrivalPort: 'Barcelona, Spain',
    priceFrom: '₹7,30,400',
    region: 'Mediterranean',
    highlights: 'Civitavecchia (Rome), Mediterranean ports, Barcelona',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/mmb4mrl6_rome.jpg'
  },
  {
    id: 'EX20270815PIRBCN',
    name: 'Eastern Mediterranean Treasures',
    ship: 'EXPLORA II',
    duration: '10 nights',
    year: 2027,
    sortDate: new Date('2027-08-15'),
    departureDate: 'August 15, 2027',
    returnDate: 'August 25, 2027',
    departurePort: 'Piraeus (Athens), Greece',
    arrivalPort: 'Barcelona, Spain',
    priceFrom: '₹8,71,500',
    region: 'Mediterranean',
    highlights: 'Piraeus (Athens), Greek Islands, Sicily, Malta, Barcelona',
    category: 'mediterranean',
    image: 'https://customer-assets.emergentagent.com/job_ocean-escapes/artifacts/xdaum4pb_barcelona.jpg'
  }
];

// Merge base itineraries with additional ones (Caribbean, South America, Middle East, EXPLORA III)
export const exploraItineraries = [...baseItineraries, ...additionalItineraries];

export const features = [
  {
    title: 'All-Suite Luxury',
    description: 'Every accommodation is a spacious oceanfront suite with private terrace, offering unparalleled comfort and elegance.',
    icon: 'hotel'
  },
  {
    title: 'All-Inclusive Excellence',
    description: 'Nine culinary experiences, unlimited fine beverages, thermal spa access, and all gratuities included.',
    icon: 'utensils'
  },
  {
    title: 'Offbeat Destinations',
    description: 'Explore smaller ports of beauty and hidden gems that large cruise ships cannot visit.',
    icon: 'anchor'
  },
  {
    title: 'Yacht-Like Experience',
    description: 'Super-yacht-inspired design with intimate atmosphere and refined European elegance.',
    icon: 'ship'
  },
  {
    title: 'Ocean Wellness',
    description: 'Where the spirit of the sea nurtures your body and soul with world-class spa and fitness programs.',
    icon: 'sparkles'
  },
  {
    title: 'Intuitive Service',
    description: 'Warm, authentic hospitality with dedicated hosts ensuring every detail is thoughtfully considered.',
    icon: 'heart'
  }
];

export const testimonials = [
  {
    quote: 'One of the first things travellers will notice is the onboard cuisine which leans into its European roots.',
    author: 'FORBES'
  },
  {
    quote: 'If you want an indulgent, elevated cruise, look no further.',
    author: 'CONDÉ NAST TRAVELER'
  },
  {
    quote: 'Like being a guest in a luxury yacht or hotel, but sailing the seas.',
    author: 'VANITY FAIR'
  }
];

export const inclusions = [
  'Nine culinary experiences with globally curated menus',
  'Unlimited fine beverages including wine and spirits',
  'Thermal spa and wellness facilities access',
  'Complimentary high-speed Wi-Fi throughout',
  'All onboard gratuities and service charges',
  'Shuttle services from port to city centres',
  'In-suite welcome champagne and refreshments',
  'Wellbeing and fitness programmes'
];
